import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import MessageModal from '../container/MessageModal';
import TextControl from '../container/customizedInputs/TextControl';
import { errorClassification } from '../errorHandler';

import usuariosServices from '../services/usuariosServices';

const CambioClave = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [claves, setClaves] = useState({
    password: "",
    new_password: "",
    new_password_repeated: ""
  });
  const [renderHTML, setRenderHTML] = useState(false);

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };


  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true ){
      setRenderHTML(true)
    } else {
      setRenderHTML(false)
    }

  }, [authInformation]);


  const cambiarClave = async () => {
    try {
      const data = await usuariosServices.cambiarClave(claves);

      handleShowModal(data.status)
      navigate(`/salir`);

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setClaves({...claves,
      [name]: value
    })
  }


  const handleFormSubmit = (e) => {
    e.preventDefault()

    cambiarClave()
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <div className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">Cambio de clave</h5>
                  <div className='row mb-3'>
                    <div className='col-sm-6'>
                      <TextControl
                        className='mb-3'
                        value={claves.password}
                        name={'password'}
                        handleInput={handleInput}
                        type='password'
                        label='Clave actual'
                        />
                    </div>
                    <div className='col-sm-6'>
                      <TextControl
                        className='mb-3'
                        value={claves.new_password}
                        name={'new_password'}
                        handleInput={handleInput}
                        type='password'
                        label='Clave nueva'
                        />
                    </div>
                    <div className='col-sm-6'>
                      <TextControl
                        className='mb-3'
                        value={claves.new_password_repeated}
                        name={'new_password_repeated'}
                        handleInput={handleInput}
                        type='password'
                        label='Repita la clave nueva'
                        />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Cambiar clave</button>
                <button className="btn btn-outline-secondary px-4" type='button' onClick={() => navigate(-1)}>Volver</button>
              </div>

            </form>
          </main>
        )
      }

     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default CambioClave;